import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';

dayjs.extend(utc);

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<App />);

serviceWorker.unregister();
